
import { getConfigList } from "http/systemConfiguration/systemConfiguration";
import React, { createContext, useEffect, useState } from "react"

  
  const SystemConfigurationContext = createContext()
  
  const SystemConfigurationProvider = ({ children }) => {
    const [config, setConfig] = useState([])
    const [inputMax, setInputMax] = useState(50);
    const [sapCreds, setSapCreds] = useState({})
    const [sapTrigger, setSapTrigger] = useState(false)
  
    useEffect(() => {
        const fetchSystemConfig = async () => {
          try {
            const response = await getConfigList();
            const input = response?.data?.data?.find((i) => i.configKey === "INPUT_MAX");
            const sapCredentials = response?.data?.data?.find((i) => i.configKey === "SAP_CREDS");
            const sapTrigger = response?.data?.data?.find((i) => i.configKey === "SAP_TRIGGER");
            setConfig(response.data);
            setInputMax(Number(input?.configValue))
            setSapCreds(JSON.parse(sapCredentials?.configValue))
            setSapTrigger(JSON.parse(sapTrigger?.configValue))

          } catch (error) {
            console.error('Failed to fetch system configuration', error);
          }
        };
    
        fetchSystemConfig();
      }, []);
  
    return (
      <SystemConfigurationContext.Provider
        value={{
          config,
          inputMax,
          sapCreds,
          sapTrigger
        }}
        
      >
        {children}
      </SystemConfigurationContext.Provider>
    )
  }
  
  export { SystemConfigurationProvider, SystemConfigurationContext }
  
